import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	chatbot: null
};

export const error = initialState;

const slice = createSlice({
	name: "application",
	initialState,
	reducers: {
		initChatbotScript: (state, action) => {
			state.chatbot = {
				active: action.payload.active,
				apiKey: action.payload.apiKey,
				scriptUrl: action.payload.scriptUrl,
				metadatas: action.payload.metadatas
			};
		}
	}
});

export const getChatbotConfig = state => state.application.chatbot;

export const { initChatbotScript } = slice.actions;

export default slice.reducer;
